<template>
  <v-container fluid class="container-locations">
    <v-container class="container-locations">
      <locations-table />
    </v-container>
  </v-container>
</template>

<script>
import LocationsTable from "@/components/LocationsTable.vue";

export default {
  name: "Locations",

  components: {
    LocationsTable,
  },
};
</script>

<style scoped>
@media screen and (max-width: 932px) {
  .container-locations {
    padding: 10px;
  }
}
</style>
